import React, { useState } from 'react';
import { Box, IconButton, Menu, MenuItem } from '@mui/material';
import GridMoreVertIcon from '@mui/icons-material/MoreVert';
import { copyAction } from '../../../../../@Common/Actions/copyAction';
import { useDispatch } from 'react-redux';

const OfferOptionsMenu = ({
    offer,
    onClickCommissionRateHistoryModal,
    onClickSyndicatedListingsModal,
    onClickEditOffer,
    openGovXIdLinkModal,
    onClickCreateTestRedemptionSession,
    canCreateTestRedemptionSession,
    handlePublish,
    openPublishModal,
    onClickDelete,
    onClickSyncOffer,
    onClickSyndicateOffer,
    canDeleteSyndicateOffer,
    canSyncOffer,
    canDeleteOffer,
    canSetStatus,
    canSyndicateOffer,
    canViewSyndicatedListings,
    onClickPublish,
    onClickUnpublish,
    onClickSyndicatedDetailsModal,
    onClickRemoveSyndicateOffer
}) => {
    const [menuAnchor, setMenuAnchor] = useState(null)
    const isShopifyOffer = offer.source.type.toLowerCase() === 'shopify'
    const isSyndicateOffer = offer.syndicateId !== null
    const canShowCreateTestRedemptionSession = !isSyndicateOffer && !isShopifyOffer && canCreateTestRedemptionSession && Boolean(offer.tokenExchangeSettings)
    const dispatch = useDispatch()

    return (
        <Box>
            {((isSyndicateOffer && canDeleteSyndicateOffer)
                || (!isSyndicateOffer && (canSyndicateOffer || (isShopifyOffer && canSyncOffer) || (!isShopifyOffer && (canDeleteOffer || (canSetStatus && offer.status !== 'Unspecified'))) || canShowCreateTestRedemptionSession)))
                &&
                <IconButton style={{ paddingTop: '9px' }} onClick={(e) => setMenuAnchor(e.currentTarget)}>
                    <GridMoreVertIcon />
                </IconButton>}
            <Menu
                anchorEl={menuAnchor}
                open={Boolean(menuAnchor)}
                onClose={() => {
                    setMenuAnchor(null);
                }}>
                {isSyndicateOffer && canDeleteSyndicateOffer
                    && (
                        <MenuItem onClick={() => { onClickSyndicatedDetailsModal(offer); setMenuAnchor(null) }}>
                            View Syndication Details
                        </MenuItem>
                    )}
                {isSyndicateOffer && canDeleteSyndicateOffer
                    && (
                        <MenuItem onClick={() => { onClickRemoveSyndicateOffer(offer); setMenuAnchor(null) }}>
                            Remove
                        </MenuItem>
                    )}
                {!isSyndicateOffer && (
                    <MenuItem onClick={() => { onClickEditOffer(offer.offerId, false); setMenuAnchor(null); }}>
                        Edit Offer
                    </MenuItem>
                )}
                {!isSyndicateOffer && !isShopifyOffer && (
                    <MenuItem onClick={() => {
                        copyAction({ dispatch, text: offer.offerId, label: 'Offer ID' });
                        setMenuAnchor(null);
                    }}>
                        Copy Offer ID
                    </MenuItem>
                )}
                {!isSyndicateOffer && !isShopifyOffer && (
                    <MenuItem onClick={() => { openGovXIdLinkModal(offer); setMenuAnchor(null); }}>
                        Copy GOVX ID Link
                    </MenuItem>
                )}
                {canShowCreateTestRedemptionSession && (
                    <MenuItem onClick={() => { onClickCreateTestRedemptionSession(offer); setMenuAnchor(null); }}>
                        Create Test Redemption Session
                    </MenuItem>
                )}
                {!isSyndicateOffer && canSyndicateOffer && (
                    <MenuItem onClick={() => { onClickSyndicateOffer(offer.offerId); setMenuAnchor(null); }}>
                        Syndicate Offer
                    </MenuItem>
                )}
                {!isSyndicateOffer && (
                    <MenuItem onClick={() => { onClickCommissionRateHistoryModal(offer); setMenuAnchor(null); }}>
                        View Commission History
                    </MenuItem>)
                }
                {canViewSyndicatedListings && offer.syndicatedListings !== null && (
                    <MenuItem onClick={() => { onClickSyndicatedListingsModal(offer); setMenuAnchor(null); }}>
                        View Syndicated Listings
                    </MenuItem>)
                }
                {!isSyndicateOffer && !isShopifyOffer && canSetStatus && (offer.status === 'Unpublished' || offer.status === 'Unspecified') && (
                    <MenuItem onClick={() => { onClickPublish(); setMenuAnchor(null); }}>
                        Publish Offer
                    </MenuItem>
                )}
                {!isSyndicateOffer && !isShopifyOffer && canSetStatus && offer.status === 'Published' && (
                    <MenuItem onClick={() => { onClickUnpublish(); setMenuAnchor(null); }}>
                        Unpublish Offer
                    </MenuItem>
                )}
                {!isSyndicateOffer && !isShopifyOffer && canDeleteOffer && (
                    <MenuItem onClick={() => { onClickDelete(); setMenuAnchor(null); }}>
                        Delete Offer
                    </MenuItem>
                )}
                {!isSyndicateOffer && isShopifyOffer && canSyncOffer && (
                    <MenuItem onClick={() => { onClickSyncOffer(offer.source.id); setMenuAnchor(null); }}>
                        Sync Offer
                    </MenuItem>
                )}
            </Menu>
        </Box>
    );
};

export default OfferOptionsMenu;